<template>
  <Navbar />
  <div class="emailvalidate">
    <p>此頁面已棄用，請使用手機簡訊驗證。</p>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import Navbar from "../components/Navbar.vue";

const router = useRouter();

// 2026-08-06：Emailvalidate 改為重導到 /phone-validate
//   - 保留路由避免外部連結失效
//   - 若使用者已登入且需要補綁手機，導向 /bind-mobile
onMounted(() => {
  const token = localStorage.getItem("ms_platform_token");
  if (token) {
    router.replace("/bind-mobile");
  } else {
    router.replace("/phone-validate");
  }
});
</script>

<style scoped>
.emailvalidate {
  min-height: 60vh;
  background-color: var(--color-primary-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-primary);
}
</style>
